import React from 'react';
import { UserCell } from 'modules/eafApproval/components/cells/common/UserCell';
import { EafApprovalCellProps } from 'modules/eafApproval/store/model/types';

export const EafApprovalGridCellEmployee = ({ employee_user_id, className }: EafApprovalCellProps) => {
    return <UserCell user_id={employee_user_id} className={className} />;
};
